import { render, staticRenderFns } from "./creatOrder.vue?vue&type=template&id=9b2851e0&scoped=true&"
import script from "./creatOrder.vue?vue&type=script&lang=ts&"
export * from "./creatOrder.vue?vue&type=script&lang=ts&"
import style0 from "./creatOrder.vue?vue&type=style&index=0&id=9b2851e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2851e0",
  null
  
)

export default component.exports